// Statik demo veri üreteci - backend yok. Deterministik.
// TEMEL ORAN: 1.000.000 ₺ yatırım = ~180 işlem, ortalama işlem = 5.555 ₺.
// Özet/rapor sayıları hesaplama (agregat) ile üretilir; tablo satırları sayfa sayfa üretilir (performans).

function mulberry32(a) {
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const rng = mulberry32(20260710);
const rand = () => rng();
const randInt = (min, max) => Math.floor(rand() * (max - min + 1)) + min;
const pick = (arr) => arr[Math.floor(rand() * arr.length)];
const round10 = (x) => Math.round(x / 10) * 10;
const pad = (n, l = 2) => String(n).padStart(l, "0");

export const AVG = 5555; // ortalama işlem tutarı (yatırım) → 1M = ~180 işlem

export const formatTRY = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: 2 }).format(n || 0);

export const formatInt = (n) => new Intl.NumberFormat("tr-TR").format(Math.round(n || 0));

export const BANKS = [
  "Ziraat Bankası", "Garanti BBVA", "Akbank", "İş Bankası", "Yapı Kredi",
  "QNB", "Enpara", "Vakıfbank", "Halkbank", "DenizBank", "TEB", "Papara",
];

export const METHODS = ["Havale", "FAST", "Papara", "Kredi Kartı", "Kripto", "QR Kod"];

const STATUSES = [
  ...Array(85).fill("Onaylandı"),
  ...Array(10).fill("Beklemede"),
  ...Array(5).fill("Reddedildi"),
];

const FIRST = [
  "Ahmet", "Mehmet", "Mustafa", "Emre", "Burak", "Kaan", "Deniz", "Cem", "Onur",
  "Serkan", "Barış", "Umut", "Efe", "Tolga", "Volkan", "Sinan", "Hakan", "Yusuf",
  "Elif", "Zeynep", "Merve", "Ece", "Selin", "Buse", "Derya", "Aslı", "Gizem", "İrem",
];
const LAST = [
  "Yılmaz", "Demir", "Kaya", "Şahin", "Çelik", "Yıldız", "Aydın", "Öztürk", "Arslan",
  "Doğan", "Kılıç", "Aslan", "Çetin", "Korkmaz", "Kurt", "Polat", "Erdoğan", "Koç",
];
const fullName = () => `${pick(FIRST)} ${pick(LAST)}`;
const nameFrom = (r) => `${FIRST[Math.floor(r() * FIRST.length)]} ${LAST[Math.floor(r() * LAST.length)]}`;
const pickFrom = (arr, r) => arr[Math.floor(r() * arr.length)];

// Gerçekçi, karışık yatırım tutarları havuzu (küçükler daha sık). Min yatırıma göre filtrelenir.
const AMOUNT_POOL = [
  1000, 1000, 1000, 1250, 1250, 1500, 1500, 1500, 1750, 1750,
  2000, 2000, 2000, 2000, 2250, 2500, 2500, 2500, 2750, 3000, 3000, 3000,
  3500, 3500, 4000, 4000, 4500, 5000, 5000, 5000, 5500, 6000, 6500,
  7000, 7500, 7500, 8000, 9000, 10000, 10000, 12000, 12500, 15000, 17500,
  20000, 25000, 30000, 40000, 50000,
];
const pickAmount = (min, r) => {
  const elig = AMOUNT_POOL.filter((v) => v >= min);
  return elig[Math.floor(r() * elig.length)];
};

const PALETTE = [
  "#78C043", "#F0813E", "#2F6FED", "#7A2FBE", "#DB2777", "#1E7A5E", "#EAB308", "#0EA5A0",
  "#EF4444", "#8B5CF6", "#14B8A6", "#F59E0B", "#3B82F6", "#EC4899", "#10B981", "#6366F1",
  "#F97316", "#06B6D4", "#A855F7", "#84CC16", "#E11D48", "#0284C7", "#65A30D", "#9333EA",
];

// Öne çıkan bayilerin 7 günlük yatırım hedefi; diğerleri 10-16M.
const SPECIAL_TOTAL = { 189: 32900000, 209: 32900000, 201: 80000000, 206: 70000000, 212: 50000000 };
const fillerTotal = (code) => (10 + ((code * 13) % 7)) * 1000000;

const rangeTeams = [];
for (let code = 189, i = 0; code <= 212; code++, i++) {
  const id = "SRL" + code;
  rangeTeams.push({
    id, name: id,
    min: code === 189 ? 1000 : 2000,
    minLabel: code === 189 ? "1.000 ₺" : "2.000 ₺",
    dayTotal: SPECIAL_TOTAL[code] || fillerTotal(code),
    cekimRatio: 0.92,
    color: PALETTE[i % PALETTE.length],
  });
}

export const TEAMS = [
  { id: "SRL001", name: "SRL001", min: 500, minLabel: "500 ₺", dayTotal: 2000000, cekimRatio: 0.9, color: "#94A3B8" },
  ...rangeTeams,
  { id: "SRL240", name: "SRL240", min: 3000, minLabel: "Özel IBAN", dayTotal: 60000000, cekimRatio: 0.9, color: "#0F766E", ozel: true },
];

const DAYS = [10, 11, 12, 13, 14, 15, 16];

// AGREGAT: bayi x gün. Tüm özet/rapor sayılarının kaynağı. İşlem adedi = tutar / AVG.
export const AGG = [];
TEAMS.forEach((team) => {
  DAYS.forEach((day) => {
    const yatirimTutar = round10((team.dayTotal / DAYS.length) * (0.85 + rand() * 0.3));
    const cekimTutar = round10(yatirimTutar * team.cekimRatio);
    AGG.push({
      teamId: team.id,
      day,
      dateISO: `2026-07-${pad(day)}`,
      dateStr: `${pad(day)}.07.2026`,
      yatirimTutar,
      cekimTutar,
      yatirimAdet: Math.max(1, Math.round(yatirimTutar / AVG)),
      cekimAdet: Math.max(0, Math.round(cekimTutar / AVG)),
      komisyon: round10(yatirimTutar * 0.03),
    });
  });
});

function genIban() {
  let s = "TR";
  for (let i = 0; i < 24; i++) s += randInt(0, 9);
  return s.replace(/(.{4})/g, "$1 ").trim();
}

export const SAHA_HESAPLARI = [];
TEAMS.forEach((t) => {
  const n = randInt(2, 4);
  for (let i = 0; i < n; i++) {
    SAHA_HESAPLARI.push({
      bayiId: t.id, minLabel: t.minLabel, hesapSahibi: fullName(),
      bank: pick(BANKS), iban: genIban(), aktif: rand() > 0.15,
    });
  }
});

const usernames = ["kral", "aslan", "efsane", "patron", "vip", "gold", "star", "mega", "turbo", "reis", "kaptan", "as"];
export const CUSTOMERS = [];
for (let i = 0; i < 48; i++) {
  const team = pick(TEAMS);
  CUSTOMERS.push({
    id: `${pick(usernames)}${randInt(10, 9999)}`,
    name: fullName(),
    bayiId: team.id,
    bakiye: round10(AVG * randInt(2, 60)),
    islem: randInt(20, 480),
    durum: rand() > 0.2 ? "Aktif" : "Pasif",
    kayit: `${pad(randInt(1, 9))}.07.2026`,
  });
}

// ---- Özet / rapor fonksiyonları (AGREGAT tabanlı) ----

function inRange(a, from, to) {
  return a.dateISO >= from && a.dateISO <= to;
}

export function summaryForFilter({ teamId = "all", method = "all", from = "2026-07-10", to = "2026-07-16" } = {}) {
  let yatirim = 0, cekim = 0, komisyon = 0, adet = 0;
  for (const a of AGG) {
    if (teamId !== "all" && a.teamId !== teamId) continue;
    if (!inRange(a, from, to)) continue;
    yatirim += a.yatirimTutar;
    cekim += a.cekimTutar;
    komisyon += a.komisyon;
    adet += a.yatirimAdet + a.cekimAdet;
  }
  if (method !== "all") {
    const f = 1 / METHODS.length;
    yatirim = round10(yatirim * f);
    cekim = round10(cekim * f);
    komisyon = round10(komisyon * f);
    adet = Math.round(adet * f);
  }
  const bakiye = yatirim - cekim;
  const bloke = round10(Math.abs(bakiye) * 0.06);
  return { yatirim, cekim, komisyon, bakiye, bloke, kullanilabilir: bakiye - bloke, adet };
}

export function bayiReport({ from = "2026-07-10", to = "2026-07-16" } = {}) {
  const gunSayisi = Math.max(1, Number(to.slice(-2)) - Number(from.slice(-2)) + 1);
  return TEAMS.map((team) => {
    let yatirim = 0, cekim = 0, komisyon = 0, yatirimAdet = 0, cekimAdet = 0;
    for (const a of AGG) {
      if (a.teamId !== team.id || !inRange(a, from, to)) continue;
      yatirim += a.yatirimTutar; cekim += a.cekimTutar; komisyon += a.komisyon;
      yatirimAdet += a.yatirimAdet; cekimAdet += a.cekimAdet;
    }
    return {
      ...team, yatirim, cekim, komisyon,
      bakiye: yatirim - cekim,
      islemAdedi: yatirimAdet,
      ortYatirim: yatirimAdet ? yatirim / yatirimAdet : 0,
      gunlukOrtCiro: yatirim / gunSayisi,
      islemBasi1M: yatirim ? yatirimAdet / (yatirim / 1000000) : 0,
    };
  });
}

export function teamSummaries({ from = "2026-07-10", to = "2026-07-16" } = {}) {
  return TEAMS.map((team) => {
    let yatirim = 0, cekim = 0, komisyon = 0, yatirimAdet = 0;
    for (const a of AGG) {
      if (a.teamId !== team.id || !inRange(a, from, to)) continue;
      yatirim += a.yatirimTutar; cekim += a.cekimTutar; komisyon += a.komisyon; yatirimAdet += a.yatirimAdet;
    }
    return {
      ...team, yatirim, cekim, komisyon,
      bakiye: yatirim - cekim,
      adet: yatirimAdet,
      hesapSayisi: SAHA_HESAPLARI.filter((h) => h.bayiId === team.id).length,
    };
  });
}

export function bayiDailyBreakdown(teamId) {
  return AGG.filter((a) => a.teamId === teamId).map((a) => ({
    gun: a.dateStr,
    yatirim: a.yatirimTutar,
    cekim: a.cekimTutar,
    komisyon: a.komisyon,
    islem: a.yatirimAdet,
  }));
}

export function dailySeries({ teamId = "all" } = {}) {
  return DAYS.map((day) => {
    let yatirim = 0, cekim = 0, adet = 0;
    for (const a of AGG) {
      if (a.day !== day) continue;
      if (teamId !== "all" && a.teamId !== teamId) continue;
      yatirim += a.yatirimTutar; cekim += a.cekimTutar; adet += a.yatirimAdet;
    }
    return { gun: `${pad(day)} Tem`, "Yatırım": Math.round(yatirim), "Çekim": Math.round(cekim), islem: adet };
  });
}

// ---- Kasa tablosu (sayfa sayfa, tembel üretim) ----

function activeDays(from, to) {
  return DAYS.filter((d) => `2026-07-${pad(d)}` >= from && `2026-07-${pad(d)}` <= to);
}

export function transactionsCount({ teamId = "all", method = "all", type = "all", from = "2026-07-10", to = "2026-07-16" } = {}) {
  let n = 0;
  for (const a of AGG) {
    if (teamId !== "all" && a.teamId !== teamId) continue;
    if (!inRange(a, from, to)) continue;
    if (type === "yatirim") n += a.yatirimAdet;
    else if (type === "cekim") n += a.cekimAdet;
    else n += a.yatirimAdet + a.cekimAdet;
  }
  if (method !== "all") n = Math.round(n / METHODS.length);
  return n;
}

let _seedCache = 2166136261;
function seedStr(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
  return h >>> 0;
}

export function transactionsPage(filter, page, perPage) {
  const { teamId = "all", method = "all", type = "all", from = "2026-07-10", to = "2026-07-16" } = filter;
  const total = transactionsCount(filter);
  const ids = TEAMS.filter((t) => teamId === "all" || t.id === teamId).map((t) => t.id);
  const days = activeDays(from, to);
  const base = `${teamId}|${method}|${type}|${from}|${to}`;
  const start = page * perPage;
  const rows = [];
  for (let i = 0; i < perPage && start + i < total; i++) {
    const idx = start + i;
    const r = mulberry32(seedStr(`${base}|${idx}`));
    const bayiId = pickFrom(ids, r);
    const team = TEAMS.find((t) => t.id === bayiId);
    const ty = type !== "all" ? type : (r() < 0.82 ? "yatirim" : "cekim");
    const amount = pickAmount(team.min, r);
    const day = pickFrom(days.length ? days : DAYS, r);
    const hh = Math.floor(r() * 24), mm = Math.floor(r() * 60);
    rows.push({
      id: idx,
      bayiId,
      musteriAdi: nameFrom(r),
      type: ty,
      method: method !== "all" ? method : pickFrom(METHODS, r),
      amount,
      bank: pickFrom(BANKS, r),
      status: pickFrom(STATUSES, r),
      dateStr: `${pad(day)}.07.2026 ${pad(hh)}:${pad(mm)}`,
    });
  }
  return { rows, total };
}

// ---- Örnek işlem listesi (Havale/FAST, Loglar için) ----
export const SAMPLE_TX = [];
(() => {
  const r = mulberry32(999001);
  for (let i = 0; i < 600; i++) {
    const team = TEAMS[Math.floor(r() * TEAMS.length)];
    const ty = r() < 0.8 ? "yatirim" : "cekim";
    const day = DAYS[Math.floor(r() * DAYS.length)];
    const hh = Math.floor(r() * 24), mm = Math.floor(r() * 60);
    SAMPLE_TX.push({
      id: 500000 + i,
      teamId: team.id,
      bayiId: team.id,
      musteriAdi: nameFrom(r),
      type: ty,
      method: METHODS[Math.floor(r() * METHODS.length)],
      amount: pickAmount(team.min, r),
      bank: BANKS[Math.floor(r() * BANKS.length)],
      status: STATUSES[Math.floor(r() * STATUSES.length)],
      dateISO: `2026-07-${pad(day)}`,
      dateStr: `${pad(day)}.07.2026 ${pad(hh)}:${pad(mm)}`,
      sortKey: day * 10000 + hh * 100 + mm,
    });
  }
  SAMPLE_TX.sort((a, b) => b.sortKey - a.sortKey);
})();

export function filterTransactions({ teamId = "all", method = "all", type = "all" } = {}) {
  return SAMPLE_TX.filter((t) => {
    if (teamId !== "all" && t.teamId !== teamId) return false;
    if (method !== "all" && t.method !== method) return false;
    if (type !== "all" && t.type !== type) return false;
    return true;
  });
}

export const DATE_MIN = "2026-07-10";
export const DATE_MAX = "2026-07-16";

export function exportCSV(rows, filename = "rapor.csv") {
  if (!rows.length) return;
  const headers = Object.keys(rows[0]);
  const csv = [
    headers.join(";"),
    ...rows.map((r) => headers.map((h) => String(r[h] ?? "").replace(/;/g, ",")).join(";")),
  ].join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
